<template>
  <el-form
    :model="form"
    :disabled="disabled"
    :rules="rules"
    ref="contractForm"
    label-width="110px"
  >
    <custom-collapse>
      <el-row>
        <el-col :span="6">
          <el-form-item label="合同类型" prop="authType">
            <el-select v-model="form.authType" class="small-form-field" @change="handleAuthTypeChange">
              <el-option
                v-for="authType in authTypeList"
                :disabled="authType.disabled"
                :key="authType.id"
                :label="authType.name"
                :value="+authType.id"
              ></el-option>
            </el-select>
            <el-button type="text" @click="form.remarkShow.authTypeRemarksShow = true">备注</el-button>
            <el-input
              v-if="form.remarkShow.authTypeRemarksShow || form.copyrightExtend.authTypeRemarks"
              v-model="form.copyrightExtend.authTypeRemarks"
              class="remark"
              placeholder="备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同编号" prop="contract">
            <el-input
              v-if="showContractInput"
              v-model="form.contract"
              style="width:400px"
              placeholder="请输入完整合同编号"
            ></el-input>
            <search-buy-task
              v-else
              :value.sync="form.contract"
              placeholder="请输入完整合同编号搜索采买任务"
              width="400px"
              search-key="contract"
              @select="handleSelectContractInfo"
            ></search-buy-task>
            <el-button type="text" @click="showContractInput = !showContractInput">{{ showContractInput ? '切换为搜索合同编号拉取内容' : '切换为直接填入合同编号' }}</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否是虚拟合同" prop="isVirtual">
            <el-radio-group v-model="form.isVirtual">
              <el-radio v-for="(name, id) in isVirtualMap" :key="id" :label="+id">{{ name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="授权方" prop="authorizer">
            <el-input v-model="form.authorizer" class="form-field"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="签约商务团队" prop="signBusinessTeam">
            <el-select
              v-model="form.signBusinessTeam"
              placeholder="请选择签约商务团队"
              class="form-field"
            >
              <el-option
                v-for="(label, value) in signBusinessTeamMap"
                :key="+value"
                :value="+value"
                :label="value + '. ' + label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商务对接人" prop="businessBroker">
            <el-input v-model="form.businessBroker" placeholder="请输入商务对接人" class="form-field"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="当前被授权主体" prop="authorizee" label-width="130px">
            <search-company
              style="width:380px"
              :value.sync="form.authorizee"
              :default-options="defaultAuthorizee"
            >
            </search-company>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="TME版权归属" prop="belongTo">
            <el-select
              v-model="form.belongTo"
              class="form-field"
            >
              <el-option
                v-for="(name, id) in belongToMap"
                :key="id"
                :label="id + '. ' + name"
                :value="+id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="原始授权时间" prop="originalDate">
            <el-date-picker
              v-model="form.originalDate"
              style="width:400px"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <template #hide>
        <el-row>
          <el-col :span="6">
            <el-form-item label="合同首发类型" prop="onlyType">
              <el-select v-model="form.onlyType" class="small-form-field">
                <el-option v-for="(name, id) in onlyTypeMap" :key="id" :label="name" :value="+id"></el-option>
              </el-select>
              <el-button type="text" @click="form.remarkShow.onlyTypeRemarksShow = true">备注</el-button>
              <el-input
                v-if="form.remarkShow.onlyTypeRemarksShow || form.copyrightExtend.onlyTypeRemarks"
                v-model="form.copyrightExtend.onlyTypeRemarks"
                class="remark"
                placeholder="备注信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合约属性" prop="attr">
              <el-select v-model="form.attr" multiple class="small-form-field">
                <el-option v-for="(name, id) in attrMap" :key="id" :label="name" :value="+id"></el-option>
              </el-select>
              <el-button type="text" @click="form.remarkShow.attrRemarksShow = true">备注</el-button>
              <el-input
                v-if="form.remarkShow.attrRemarksShow || form.copyrightExtend.attrRemarks"
                v-model="form.copyrightExtend.attrRemarks"
                class="remark"
                placeholder="备注信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="原始权利人" prop="originalObligee">
              <el-input v-model="form.originalObligee" placeholder="" class="form-field"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同来源">
              <el-select
                v-model="form.copyrightType"
                class="form-field"
              >
                <el-option
                  v-for="(name, id) in copyrightTypeMap"
                  :key="id"
                  :label="id + '. ' + name"
                  :value="+id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结算方式" prop="settleMethod">
              <el-select
                multiple
                v-model="form.settleMethod"
                placeholder="请选择结算方式"
                class="small-form-field"
              >
                <el-option
                  v-for="(label, value) in settleMethodMap"
                  :key="value"
                  :value="+value"
                  :label="label"
                ></el-option>
              </el-select>
              <el-button
                type="text"
                @click="form.remarkShow.settleMethodRemarksShow = true"
              >
                备注
              </el-button>
              <el-input
                v-if="form.remarkShow.settleMethodRemarksShow || form.copyrightExtend.settleMethodRemarks"
                v-model="form.copyrightExtend.settleMethodRemarks"
                class="remark"
                placeholder="备注信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签约形式" prop="signForm">
              <el-select
                v-model="form.signForm"
                placeholder="请选择签约形式"
                class="form-field"
              >
                <el-option
                  v-for="(label, value) in signFormMap"
                  :key="value"
                  :value="+value"
                  :label="value + '. ' + label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同公司类型">
              <el-select
                v-model="form.companyType"
                class="form-field"
              >
                <el-option
                  v-for="(name, id) in typeMap"
                  :key="id"
                  :label="id + '. ' + name"
                  :value="+id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结算条件" prop="settleTerms">
              <el-input v-model="form.settleTerms" class="form-field" placeholder="请输入结算条件"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签约平台" prop="signPlatform">
              <el-select v-model="form.signPlatform" multiple class="form-field">
                <el-option v-for="(name, key) in signPlatformMap" :key="key" :label="name" :value="+key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <template v-if="showWmAuthType">
            <el-col :span="6">
              <el-form-item label="词曲授权类型" prop="wmAuthType">
                <el-select v-model="form.wmAuthType" placeholder="选择词曲授权类型" class="form-field">
                  <el-option v-for="(name, id) in wmAuthTypeMap" :key="id" :label="name" :value="+id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="符合维权条件" prop="licenseValid">
                <el-select v-model="form.licenseValid" placeholder="" class="form-field">
                  <el-option v-for="(name, id) in licenseValidMap" :key="id" :label="name" :value="+id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="6">
            <el-form-item label="免费授权合同">
              <el-radio-group v-model="form.isFree">
                <el-radio v-for="(name, id) in isFreeMap" :key="id" :label="+id">{{ name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否全曲库">
              <el-radio-group v-model="form.isAllSongbank">
                <el-radio v-for="(name, id) in isAllSongbankMap" :key="id" :label="+id">{{ name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否完整">
              <el-radio-group v-model="form.rightComplete">
                <el-radio v-for="(name, id) in rightCompleteMap" :key="id" :label="+id">{{ name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否禁止\限制链接" label-width="140px">
              <el-radio-group v-model="form.noLink" class="small-form-field">
                <el-radio v-for="(name, id) in noLinkMap" :key="id" :label="+id">{{ name }}</el-radio>
              </el-radio-group>
              <el-button type="text" @click="form.remarkShow.noLinkRemarksShow = true">备注</el-button>
              <el-input
                v-if="form.remarkShow.noLinkRemarksShow || form.copyrightExtend.noLinkRemarks"
                v-model="form.copyrightExtend.noLinkRemarks"
                class="remark"
                placeholder="备注信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="其他限制" prop="otherLimit">
              <el-input v-model="form.otherLimit" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="form.copyrightExtend.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </custom-collapse>
  </el-form>
</template>

<script>
import {
  authTypeMap,
  authTypeList,
  isFreeMap,
  noLinkMap,
  isAllSongbankMap,
  attrMap,
  wmAuthTypeMap,
  licenseValidMap,
  rightCompleteMap,
  typeMap,
  CopyrightTypeMap,
  settleMethodMap,
  signPlatformMap,
  signBusinessTeamMap,
  isVirtualMap,
  belongToMap,
  defaultAuthorizee,
  signFormMap,
  onlyTypeMap
} from '../../const'
import SearchCompany from '@/components/SearchCompany'
import CustomCollapse from '@/components/CustomCollapse'
import SearchBuyTask from '@/components/SearchBuyTask'

export default {
  name: 'CopyrightForm',
  components: {
    SearchCompany,
    CustomCollapse,
    SearchBuyTask
  },
  props: {
    contract: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      authTypeMap,
      isFreeMap,
      noLinkMap,
      isAllSongbankMap,
      attrMap,
      authTypeList,
      wmAuthTypeMap,
      licenseValidMap,
      rightCompleteMap,
      typeMap,
      settleMethodMap,
      signPlatformMap,
      copyrightTypeMap: CopyrightTypeMap.codeNameMap,
      signBusinessTeamMap,
      isVirtualMap,
      belongToMap,
      signFormMap,
      defaultAuthorizee,
      onlyTypeMap,

      form: null,
      rules: {
        authType: [
          { required: true, message: '请选择合同类型', trigger: 'change' }
        ],
        // contract: [
        //   { required: true, message: '请输入合同编号', trigger: 'blur' }
        // ],
        belongTo: [
          { required: true, message: '请选择TME版权归属', trigger: 'change' }
        ],
        authorizee: [
          { required: true, message: '请选择当前被授权主体', trigger: 'change' }
        ],
      },
      showContractInput: false
    }
  },
  computed: {
    /**
     * @returns {Boolean}
     */
    showWmAuthType() {
      const form = this.form
      return form.authType === 2 || form.authType === 3
    },
  },
  watch: {
    contract: {
      immediate: true,
      deep: true,
      handler() {
        this.form = this.contract
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.contractForm.validate()
    },
    handleAuthTypeChange() {
      if (!this.showWmAuthType) {
        this.form.wmAuthType = 0
        this.form.canCoverFrom = null
        this.form.canCoverTo = null
        this.form.canCover = 0
        this.form.coverNeedPermission = 0
      }
    },
    handleSelectContractInfo(item) {
      this.$emit('select', item)
    }
  }
}
</script>

<style scoped lang="scss">
.remark {
  // margin-top: 8px;
  max-width: 120px;
}
.el-icon-plus {
  cursor: pointer;
  font-weight: 700;
  // color: $primary;
}

.el-icon-delete {
  cursor: pointer;
  font-weight: 700;
  color: $danger;
}
.label {
  padding-left: 8px;
}
</style>
